/*
  Odroczone ładowanie filmów w tle (video[data-deferred-video]).
  Źródła montowane dopiero, gdy element zbliża się do viewportu (300px marginesu),
  pauza gdy zjedzie z ekranu. HLS (m3u8) tylko tam, gdzie gra natywnie (Safari/iOS) —
  adaptacyjny bitrate sprawia, że film rusza szybko i sam podnosi jakość.
  Skrypt jest idempotentny — może być dołączony przez wiele sekcji naraz.
*/
(function () {
  if (window.SelvaDeferredVideos) return;

  function tryPlay(video) {
    video.muted = true;
    var playPromise = video.play();
    if (playPromise && playPromise.catch) playPromise.catch(function () {});
  }

  function mount(video) {
    if (video.dataset.dvMounted) return;
    video.dataset.dvMounted = '1';
    var sources;
    try {
      sources = JSON.parse(video.getAttribute('data-sources')) || [];
    } catch (e) {
      sources = [];
    }
    var hls = [];
    var mp4 = [];
    sources.forEach(function (s) {
      if (s.format === 'm3u8') hls.push(s);
      else if (s.format === 'mp4') mp4.push(s);
    });
    var chosen;
    if (hls.length && video.canPlayType('application/vnd.apple.mpegurl')) {
      chosen = hls.concat(mp4);
    } else if (mp4.length) {
      mp4.sort(function (a, b) { return a.height - b.height; });
      chosen = [mp4[mp4.length - 1]];
    } else {
      chosen = sources;
    }
    chosen.forEach(function (s) {
      var el = document.createElement('source');
      el.src = s.url;
      el.type = s.mime;
      video.appendChild(el);
    });
    video.preload = 'auto';
    video.load();

    /*
      Watchdog: niektóre przeglądarki deklarują HLS w canPlayType (np. nowe Chromium),
      ale mogą się na nim zawiesić bez zgłoszenia błędu — wtedy fallback <source>
      nie zadziała. Jeśli po 4 s nie ma nawet metadanych, przełączamy na MP4.
    */
    if (chosen[0] && chosen[0].format === 'm3u8' && mp4.length) {
      setTimeout(function () {
        if (video.readyState === 0 && !document.hidden && !video.dataset.dvSwapped) {
          video.dataset.dvSwapped = '1';
          while (video.firstChild) video.removeChild(video.firstChild);
          var best = mp4[mp4.length - 1];
          var el = document.createElement('source');
          el.src = best.url;
          el.type = best.mime;
          video.appendChild(el);
          video.load();
          tryPlay(video);
        }
      }, 4000);
    }
  }

  var observer = null;

  function scan() {
    var videos = document.querySelectorAll('video[data-deferred-video]:not([data-dv-observed])');
    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (video) {
        video.setAttribute('data-dv-observed', '1');
        mount(video);
        tryPlay(video);
      });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting) {
              mount(video);
              if (video.paused) tryPlay(video);
            } else if (video.dataset.dvMounted && !video.paused) {
              video.pause();
            }
          });
        },
        { rootMargin: '300px 0px' }
      );
    }
    videos.forEach(function (video) {
      video.setAttribute('data-dv-observed', '1');
      observer.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);

  window.SelvaDeferredVideos = { refresh: scan };
})();